import { createSlice } from "@reduxjs/toolkit";

import {
  getWallet,
  getCryptoOrderList,
  getWalletActivities,
  createWallet,
} from "./thunk";

interface Wallet {
  provider: number;
  wallets: [
    {
      id: any;
      name: any;
      balance: any;
      wallet_type: any;
      created_at: any;
      updated_at: any;
      crypto_currency_id: any;
      network_id: any;
      status_id: any;
      fiat_currency_id: any;
      wallet_entity_id: any;
    }
  ];
}

interface walletsState {
  wallet: Wallet[];
  walletActivities: [];
  cryptoOrders: [];
  error: {};
  loading: boolean;
}

export const initialState: walletsState = {
  wallet: [],
  walletActivities: [],
  cryptoOrders: [],
  error: {},
  loading: true,
};

const CryptoSlice = createSlice({
  name: "CryptoSlice",
  initialState,
  reducers: {
    listWallets(state) {
      state.loading = true;
      state.error = {};
    },
    fetchWalletsSuccess(state, action) {
      state.loading = false;
      state.wallet = action.payload;
    },
    fetchWalletsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWallet.fulfilled, (state: any, action: any) => {
      state.wallet = action.payload;
      // console.log(action.payload);
    });

    builder.addCase(getWallet.rejected, (state: any, action: any) => {
      state.error = action.payload ? action.payload?.error : null;
    });

    builder.addCase(createWallet.fulfilled, (state: any, action: any) => {
      state.wallet = action.payload;
    });
    builder.addCase(createWallet.rejected, (state: any, action: any) => {
      state.error = action.payload ? action.payload?.error : null;
    });
    // ----------------------------------------------
    builder.addCase(getCryptoOrderList.fulfilled, (state: any, action: any) => {
      state.cryptoOrders = action.payload;
      state.loading = true;
    });

    builder.addCase(getCryptoOrderList.rejected, (state: any, action: any) => {
      state.error = action.payload ? action.payload?.error : null;
    });

    builder.addCase(
      getWalletActivities.fulfilled,
      (state: any, action: any) => {
        state.walletActivities = action.payload;
        state.loading = true;
      }
    );
    builder.addCase(getWalletActivities.rejected, (state: any, action: any) => {
      state.error = action.payload ? action.payload?.error : null;
    });
  },
});

export const { listWallets, fetchWalletsFailure, fetchWalletsSuccess } =
  CryptoSlice.actions;

export default CryptoSlice.reducer;
